
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import AcademySidemenuLayout from '@/components/organisms/layout/AcademySidemenuLayout.vue'
import TitlePanel from '@/components/organisms/TitlePanel.vue'
import AcademyBranchListPanel from '@/components/organisms/manage/AcademyBranchListPanel.vue'
import { BranchList } from '@/models/manage/BranchList'

/**
 * 教室一覧
 */
@Component({
  components: {
    AcademySidemenuLayout,
    TitlePanel,
    AcademyBranchListPanel,
  },
})
export default class AcademyBranchList extends Vue {
  /** 教室一覧パネル */
  @Ref()
  academyBranchListPanel!: AcademyBranchListPanel

  /** 教室一覧 */
  @Prop()
  private branchList!: BranchList[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** 検索ボタン押下時の処理 */
  @Prop()
  private eventSearchStudent!: () => void

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /**
   * 検索欄に入力された文字列
   *
   * @returns 入力された文字列
   */
  public get textInputedSearch(): string {
    return this.academyBranchListPanel.textInputed
  }
}
